import Promise from 'lodash/_Promise';

export default {
  getFunerals: state => state.funerals,
  getDetail: state => state.detail,
  getComment: state => state.detail.commentList,
  getPageInfo: state => state.condition,

  getAnnouncement: state => state.announcement,
  getAnnouncementCondition: state => state.announcementCondition,
  getAnnouncementList: state => state.announcementList
};
